function get100dvh() {
  const el = document.createElement('div');
  el.style.position = 'absolute';
  el.style.top = '0';
  el.style.height = '-webkit-fill-available';
  el.style.pointerEvents = 'none';
  el.style.opacity = '0';
  el.style.zIndex = '-1';
  document.body.appendChild(el);
  const computedHeight = parseFloat(getComputedStyle(el).height);
  document.body.removeChild(el);
  return computedHeight > 0 ? computedHeight : window.innerHeight;
}


function busResize() {
  function onResize() {
    window.ww = document.documentElement.offsetWidth;
    window.wh = get100dvh(); // ou innerHeight si tu préfères

    document.documentElement.style.setProperty('--vw', window.ww + "px");
    document.documentElement.style.setProperty('--vh', window.wh + "px");

    window.gutter = parseInt(getComputedStyle(document.body).getPropertyValue('--gutter'));
    window.margin = parseInt(getComputedStyle(document.body).getPropertyValue('--margin'));

    bus.emit('resize');
  }

  onResize();
  bus.on('resizeNow', onResize);
  window.addEventListener('resize', _.debounce(onResize, 100));
}

export default busResize;
